module.exports = __webpack_public_path__ + "img/seed_tossed_to_hit_harrys_head.9016e895.jpg";